// community-courses.js
function createCommunityBlock(data) {
  const onClick = () => window.location.href = `/community/my/${data.handle}`;

  // ----- main container <div> -----
  const block = document.createElement('div');
  block.className = 'col-md-4 col-lg-4 col-sm-6 col-xs-12 courseBlock';
  
  // ----- image -----
  const img = document.createElement('img');
  img.src = data.image;
  img.loading = 'lazy';
  img.alt = data.name;
  img.onclick = onClick;
  
  // ----- infoWrapper (div) -----
  const infoWrapper = document.createElement('div');
  infoWrapper.className = 'infoWrapper';
  
  // ----- absoluteInfo (div) -----
  const absoluteInfo = document.createElement('div');
  absoluteInfo.className = 'absoluteInfo';
  
  // ----- h4 title -----
  const titleEl = document.createElement('h4');
  titleEl.textContent = data.name;
  titleEl.onclick = onClick;
  
  // ----- p description -----
  const descEl = document.createElement('p');
  descEl.className = 'courseDescription';
  descEl.textContent = data.description;
  descEl.onclick = onClick;
  
  // ----- button "Acceder" -----
  const btn = document.createElement('button');
  btn.textContent = 'Acceder';
  btn.setAttribute('data-prod-handle', data.handle);
  btn.setAttribute('data-prod-id', data.id);
  btn.setAttribute('data-prod-title', data.name);
  btn.setAttribute('data-prod-subtitle', data.description);
  btn.setAttribute('data-prod-shop', data.shop);
  btn.onclick = onClick;
  
  // ----- assemble structure -----
  absoluteInfo.appendChild(titleEl);
  absoluteInfo.appendChild(descEl);
  infoWrapper.appendChild(absoluteInfo);
  infoWrapper.appendChild(btn);

  block.appendChild(img);
  block.appendChild(infoWrapper);

  return block;
}

window.addEventListener("onCoursesRendered", async () => {
  // Regular expression that allows trailing slash
  const regex = /\/apps\/my\/courses\/list\/?(?:[^\/?#]*\??.*)?$/;
  
  if (regex.test(window.location.href)) {
    const customerId = window.CoursesPlus.customerId ? `&customer_id=${window.CoursesPlus.customerId}` : '';
    const tags = window.CoursesPlus.tags && window.CoursesPlus.tags.length < 2500 ? `&customer_tags=${window.CoursesPlus.customerId}` : '';
    const productIds = '';

    const url = `https://community.architechpro.cc/api/communities?shop=${Shopify.shop}` + customerId + tags + productIds;
  
    try {
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ckLwb9k0gofuMqxRrRN67DZGqnuFxNlLfbzzy2geGHoznVj8djpxltdACwIHYhE0Sysf2W4LH6quibL2`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      const parent = document.querySelector('.appendWrapper');

      data?.communities.forEach(community => {
        const block = createCommunityBlock(community);
        parent.appendChild(block);
      });
    } catch (error) {
      console.error('Fetch failed:', error);
    }
  } else {
    console.log('FAIL on try to move elements');
  }
});